import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  spfSearchParameters: {
    dtFim: "",
    dtInicio: "",
    sqOs: "",
    gerouOs: "",
    sqOrigem: "",
    sqCiclo: "",
    sqTipoAcao: "",
    sqOrgao: "",
    identificador: "",
    sqHomologador: "",
    sqStatus: "",
    numSpf: "",
  },
  filterButton: false,
  pathname: "",
};

const spfSearchSlice = createSlice({
  name: "spfSearch",
  initialState,
  reducers: {
    salvarEstado(state, action) {
      state.spfSearchParameters = { ...action.payload };
    },
    estadoBotao(state, action) {
      state.filterButton = action.payload;
    },
    estadoPathname(state, action) {
      state.pathname = action.payload;
    },
    reset: () => initialState,
  },
});

export const spfSearchActions = spfSearchSlice.actions;

export default spfSearchSlice.reducer;
